import React, { Component } from 'react';

import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";

momentDurationFormatSetup(moment);

import utils from 'Utils/index.js';
import style from './style.scss';

import LeadsListContainer from 'Components/leads/LeadsList/LeadsListContainer'


const CallsListItem = ({call: {id, date, phone, duration, call_type, client,
ended, answered}, app_data}) => {

  const CONSTANTS = app_data.constants;
  const date_formated = utils.format_date(new Date(date), {
    with_time: true
  });
  const duration_formated = moment.duration(duration*1, "seconds").format('mm:ss', {
    trim: false
  });
  const direction_text = (call_type == CONSTANTS.INCOMING_CALL) ? 'вх' : 'ис';
  const client_name = client ? client.name : '';
  const client_id = client ? client.id : false;
  const leads = (client && client.leads) || [];
  let call_status_class = '';

  if(call_type != CONSTANTS.INCOMING_CALL) {

    if(!ended) {
      call_status_class = 'calls_list_item_current';
    }
    
  } else if(answered && !ended) {
    call_status_class = 'calls_list_item_current';
  } else if(!answered && !ended) {
    call_status_class = 'calls_list_item_not_answered_yet';
  } else if(!answered && ended) {
    call_status_class = 'calls_list_item_not_answered';
  }

  return (<tr>
    <td className={`calls_list_item__id_td calls__td ${call_status_class}`}>{id}</td>
    <td className="calls_list_item__td_date">{date_formated}</td>
    <td className="calls_list_item__td_duration">{duration_formated}</td>
    <td className="calls_list_item__td_phone">{`${direction_text} ${phone}`}</td>
    <td className="calls_list_item__td">{client_name}</td>
    <td className="calls_list_item__td">

      <LeadsListContainer client={{
        ...client,
        phone
      }} leads={leads} client_id={client_id} app_data={app_data}/>

    </td>
  </tr>);
};

export default CallsListItem;